
{
  "familyId": "STU-INHOUDSOPGAVE",
  "questions": [
    {
      "id": "STU-INHOUDSOPGAVE-001",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Waarvoor gebruik je een inhoudsopgave?",
      "context": null,
      "options": [
        "Om snel te zien welke onderwerpen in een boek staan en op welke pagina.",
        "Om de betekenis van moeilijke woorden op te zoeken.",
        "Om te zien wie het boek heeft geschreven.",
        "Om een samenvatting van het boek te lezen."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wat is een inhoudsopgave?",
            "content": "Een inhoudsopgave staat voorin een boek. Het laat zien welke hoofdstukken of onderwerpen erin staan, met de paginanummers erbij. Zo vind je snel wat je zoekt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_doel",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Een inhoudsopgave staat voorin een boek en laat zien welke hoofdstukken of onderwerpen erin staan, met de bijbehorende paginanummers. Zo kun je snel vinden wat je zoekt zonder het hele boek te lezen. Onthoud: inhoudsopgave = overzicht van onderwerpen + paginanummers.",
        "solutionSteps": [
          "Wat staat er in een inhoudsopgave?",
          "→ Een lijst van hoofdstukken of onderwerpen",
          "→ Met paginanummers erbij",
          "Waarvoor? → Om snel te vinden wat je zoekt"
        ],
        "distractorExplanations": {
          "0": "Goed! Een inhoudsopgave toont de onderwerpen en paginanummers.",
          "1": "Je dacht waarschijnlijk dat een inhoudsopgave woorden uitlegt. Maar voor de betekenis van woorden gebruik je een woordenlijst of woordenboek. Een inhoudsopgave toont alleen onderwerpen en paginanummers.",
          "2": "Je dacht waarschijnlijk dat de schrijver in de inhoudsopgave staat. Maar de naam van de schrijver staat op de voorkant of het titelblad. De inhoudsopgave toont alleen onderwerpen en paginanummers.",
          "3": "Je dacht waarschijnlijk dat de inhoudsopgave een samenvatting is. Maar een samenvatting staat op de achterflap of in een apart hoofdstuk. De inhoudsopgave toont alleen onderwerpen en paginanummers."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-002",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Op welke pagina begint het hoofdstuk over planten?",
      "context": null,
      "options": ["Pagina 12", "Pagina 4", "Pagina 20", "Pagina 2"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "📖 Inhoudsopgave",
            "content": "Hoofdstuk 1: Dieren in de jungle ......... 4\nHoofdstuk 2: Planten in de jungle ........ 12\nHoofdstuk 3: Het klimaat ................. 20",
            "icon": "book"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inhoudsopgave aflezen",
            "content": "Zoek het onderwerp 'planten' in de inhoudsopgave. Dat staat bij Hoofdstuk 2: Planten in de jungle. Het getal erachter (12) is het paginanummer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_paginanummer",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "In de inhoudsopgave staat achter 'Planten in de jungle' het getal 12. Dat is het paginanummer waar dat hoofdstuk begint. Onthoud: zoek het onderwerp in de lijst en lees het getal erachter af — dat is de pagina.",
        "solutionSteps": [
          "Zoek het onderwerp 'planten' in de inhoudsopgave",
          "Gevonden: Hoofdstuk 2: Planten in de jungle",
          "Lees het getal erachter af: 12",
          "Antwoord: het hoofdstuk begint op pagina 12"
        ],
        "distractorExplanations": {
          "0": "Goed! Hoofdstuk 2 over planten begint op pagina 12.",
          "1": "Je dacht waarschijnlijk dat het plantenhoofstuk op pagina 4 begint. Maar pagina 4 hoort bij Hoofdstuk 1 (Dieren in de jungle). Het plantenhoofstuk (Hoofdstuk 2) begint op pagina 12. Onthoud: lees het getal af achter het juiste onderwerp.",
          "2": "Je dacht waarschijnlijk dat het plantenhoofstuk op pagina 20 begint. Maar pagina 20 hoort bij Hoofdstuk 3 (Het klimaat). Het plantenhoofstuk begint op pagina 12. Onthoud: kijk bij het juiste hoofdstuk.",
          "3": "Je dacht waarschijnlijk dat het plantenhoofstuk op pagina 2 begint. Maar pagina 2 staat niet in deze inhoudsopgave. Het plantenhoofstuk begint op pagina 12. Onthoud: gebruik alleen de getallen die in de inhoudsopgave staan."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-003",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Hoeveel pagina's telt hoofdstuk 2 (van pagina 8 tot het begin van hoofdstuk 3)?",
      "context": null,
      "options": ["7 pagina's", "8 pagina's", "15 pagina's", "6 pagina's"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "rule",
          "data": {
            "title": "📖 Inhoudsopgave",
            "content": "Hoofdstuk 1: De Middeleeuwen ............ 3\nHoofdstuk 2: Ridders en kastelen ........ 8\nHoofdstuk 3: Het dagelijks leven ........ 15\nHoofdstuk 4: Het einde van de Middeleeuwen .. 22",
            "icon": "book"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Pagina's tellen",
            "content": "Hoofdstuk 2 begint op pagina 8 en hoofdstuk 3 begint op pagina 15. Het aantal pagina's van hoofdstuk 2 = 15 − 8 = 7 pagina's.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_paginas_tellen",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Hoofdstuk 2 begint op pagina 8 en hoofdstuk 3 begint op pagina 15. Dus hoofdstuk 2 loopt van pagina 8 t/m pagina 14: dat zijn 15 - 8 = 7 pagina's. Onthoud: trek het beginpaginanummer af van het volgende hoofdstuk.",
        "solutionSteps": [
          "Hoofdstuk 2 begint op pagina 8",
          "Hoofdstuk 3 begint op pagina 15",
          "Aantal pagina's = 15 - 8 = 7",
          "Check: pagina 8, 9, 10, 11, 12, 13, 14 = 7 pagina's ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 15 - 8 = 7 pagina's (pagina 8 t/m 14).",
          "1": "Je dacht waarschijnlijk dat het beginpaginanummer (8) het aantal pagina's is. Maar 8 is de pagina waar het hoofdstuk begint, niet het aantal pagina's. Reken: 15 - 8 = 7 pagina's. Onthoud: trek de paginanummers van elkaar af.",
          "2": "Je dacht waarschijnlijk dat 15 het aantal pagina's is. Maar 15 is het paginanummer waar hoofdstuk 3 begint. Het aantal pagina's van hoofdstuk 2 = 15 - 8 = 7. Onthoud: het paginanummer is niet hetzelfde als het aantal pagina's.",
          "3": "Je dacht waarschijnlijk dat het 6 pagina's zijn. Maar 15 - 8 = 7, niet 6. Tel na: pagina 8, 9, 10, 11, 12, 13, 14 = 7 pagina's. Onthoud: controleer je rekenwerk door de pagina's te tellen."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-004",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Waar in een boek vind je de inhoudsopgave?",
      "context": null,
      "options": [
        "Voorin het boek, na de titelpagina",
        "Achterin het boek, na het laatste hoofdstuk",
        "In het midden van het boek",
        "Op de achterflap van het boek"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Waar staat de inhoudsopgave?",
            "content": "De inhoudsopgave staat altijd voorin het boek, vlak na de titelpagina. Achterin vind je soms een register (index) of woordenlijst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_locatie",
      "variantIndex": 4,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De inhoudsopgave staat altijd voorin het boek, vlak na de titelpagina. Zo kun je meteen zien wat er in het boek staat voordat je begint te lezen. Onthoud: inhoudsopgave = voorin, register/index = achterin.",
        "solutionSteps": [
          "Waar staat de inhoudsopgave in een boek?",
          "→ Voorin het boek, na de titelpagina",
          "Waarom? → Zodat je meteen kunt zien wat erin staat",
          "Let op: achterin staat soms een register (index)"
        ],
        "distractorExplanations": {
          "0": "Goed! De inhoudsopgave staat voorin het boek.",
          "1": "Je dacht waarschijnlijk dat de inhoudsopgave achterin staat. Maar achterin vind je soms een register (index) of woordenlijst. De inhoudsopgave staat altijd voorin. Onthoud: inhoudsopgave = voorin, register = achterin.",
          "2": "Je dacht waarschijnlijk dat de inhoudsopgave in het midden staat. Maar de inhoudsopgave staat altijd voorin het boek, zodat je meteen kunt zien wat erin staat. In het midden staan gewoon hoofdstukken.",
          "3": "Je dacht waarschijnlijk dat de inhoudsopgave op de achterflap staat. Maar op de achterflap staat een korte beschrijving (flaptekst) van het boek. De inhoudsopgave met paginanummers staat voorin."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-005",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Je wilt iets weten over 'vulkanen'. Je hebt een boek over de aarde. Wat doe je als eerste?",
      "context": null,
      "options": [
        "Kijk in de inhoudsopgave of er een hoofdstuk over vulkanen is.",
        "Begin het boek van voren af aan te lezen.",
        "Sla het boek willekeurig open.",
        "Lees de achterflap."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Slim zoeken in een boek",
            "content": "Als je snel iets wilt vinden, kijk je eerst in de inhoudsopgave. Daar zie je welke hoofdstukken er zijn en op welke pagina ze beginnen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_strategie",
      "variantIndex": 5,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Als je snel iets wilt vinden in een boek, kijk je eerst in de inhoudsopgave. Daar zie je meteen of er een hoofdstuk over vulkanen is en op welke pagina dat begint. Onthoud: de inhoudsopgave is je snelste hulpmiddel om informatie te vinden.",
        "solutionSteps": [
          "Je zoekt informatie over vulkanen",
          "Stap 1: open het boek voorin bij de inhoudsopgave",
          "Stap 2: zoek of er een hoofdstuk over vulkanen staat",
          "Stap 3: lees het paginanummer af en sla dat op"
        ],
        "distractorExplanations": {
          "0": "Goed! De inhoudsopgave is de snelste manier om te vinden wat je zoekt.",
          "1": "Je dacht waarschijnlijk dat je het hele boek moet lezen. Maar dat kost veel te veel tijd als je alleen iets over vulkanen wilt weten. Gebruik de inhoudsopgave om snel het juiste hoofdstuk te vinden. Onthoud: slim zoeken bespaart tijd.",
          "2": "Je dacht waarschijnlijk dat willekeurig bladeren werkt. Maar dat is niet efficiënt — je kunt lang zoeken zonder het juiste hoofdstuk te vinden. De inhoudsopgave brengt je direct naar de juiste pagina.",
          "3": "Je dacht waarschijnlijk dat de achterflap helpt. Maar de achterflap geeft een algemene beschrijving van het boek, niet de paginanummers van specifieke onderwerpen. Gebruik de inhoudsopgave voor paginanummers."
        }
      }
    }
  ]
}
